import { ACTION_COLORS, Button, ICON_NAMES } from '@reverse-hr/design-system';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useStoreState } from 'easy-peasy';
import { jobStoreSelector } from '@model/Job/Job.selectors';
import type { TChatToggleProps } from '@components/Molecules/Chat/Chat.types';

export const ChatToggle: FC<TChatToggleProps> = ({ isOpen, onToggle }) => {
  const job = useStoreState(jobStoreSelector);

  const { t } = useTranslation('', {
    keyPrefix: 'candidateDetails.chat',
  });

  const manager = job?.recruitmentConsultant ?? job?.salesConsultant;

  const labelIcon = isOpen
    ? ICON_NAMES.CHEVRON_BIG_DOWN
    : ICON_NAMES.CHEVRON_BIG_UP;

  return (
    <Button
      className="ev-chat__toggle"
      color={ACTION_COLORS.ACCENT}
      onClick={onToggle}
      rightIcon={labelIcon}
    >
      <span className="ev-chat__toggle-content">
        {t('toggleButton', {
          context: isOpen ? 'open' : '',
          managerName: manager?.firstName,
        })}
      </span>

      {isOpen && (
        <span className="ev-chat__toggle-hint">{t('toggleCloseHint')}</span>
      )}
    </Button>
  );
};
